import React, { Component, } from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
// import './Profile.css'
import './../../styles/css/screens/Profile/profile.css'
import {CCUtils, ImageUtils, CCAppEventLogger, strings, CCActions, ReAuth, FirebaseUtils, CCMoreModalItem, CCButton, CCInput} from "./../../cc-imports";

class Profile extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {
            displayName : '',
            email : '',
            user: {},
            displayNameErr : null,
            emailErr : null,
            dpLoading : false,
            loading : false,
            screen : 'profile',

        };
        this._validateAndUpdateDisplayName=this._validateAndUpdateDisplayName.bind(this);
        this._reAuthenticate=this._reAuthenticate.bind(this);
        this._uploadProfilePicture=this._uploadProfilePicture.bind(this);
        this._loadValues=this._loadValues.bind(this);
        this._updateDetails=this._updateDetails.bind(this);

    }

    componentWillMount(){
        /*BackHandler.addEventListener('hardwareBackPress', () => {
            if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
                this.props.actions.goBack();
                return true;
            }
            return false;
        });*/
    }

    _loadValues(user){
        this.setState({
            email : user.email,
            displayName : user.displayName
        });
    }

    componentDidMount() {
        const user = this.props.user.user;
        this._loadValues(user);
    }

    componentWillReceiveProps(nexProps){
        if(CCUtils.userUpdated(this.props.user, nexProps.user)){
            this._loadValues(nexProps.user.user)
        }
    }

    _uploadProfilePicture () {
        this.setState({dpLoading:true});
        CCAppEventLogger.logAppEvent("ProfilePicUpdateClicked",{});
        ImageUtils.openProfileImagePicker((uri, response)=>{
            this.setState({dpLoading : true});
            ImageUtils.uploadProfilePicture(this.props.user.user.id, uri,response,(success)=>{
                ImageUtils.getProfilePicThumbnail(this.props.user.user.id, (thumbnailurl)=>{
                    this.props.actions.updateUser(this.props.user.user.id, {imageUrl : success.downloadURL, thumbnailUrl: thumbnailurl});
                    this.setState({dpLoading : false});
                }, ()=>{
                    this.props.actions.updateUser(this.props.user.user.id, {imageUrl : success.downloadURL});
                    this.setState({dpLoading : false});
                })
                CCAppEventLogger.logAppEvent("ProfilePicUpdateCompleted",{});
            }, (err)=>{
                this.setState({dpLoading : false});
                CCAppEventLogger.logAppEvent("ProfilePicUpdateFailed",{});
            });
        })
    }

    _validateAndUpdateDisplayName(value, callback) {
        CCAppEventLogger.logAppEvent("DisplayNameUpdateClicked",{});
        FirebaseUtils.updateDisplayName(value)
        this.props.actions.updateUser(this.props.user.user.id, {displayName : value}).then(()=>{
            callback && callback();
        })
    }

    /*_validateAndUpdateEmail(value, callback) {
        CCAppEventLogger.logAppEvent("EmailUpdateClicked",{});
        this.props.actions.openReAuthModal({reauth : true,callback:()=>{
                FirebaseUtils.updateEmail(value, (err)=>{
                    if(err){
                        this.setState({emailErr : err});
                    }else {
                        callback && callback();
                        this.props.actions.updateUser(this.props.user.user.id, {email : value});
                        CCAppEventLogger.logAppEvent("EmailUpdateCompleted",{});
                    }
                });
            }});
    }
    */
    _reAuthenticate() {
        this.setState({screen : 'reAuth'});
    }

    _onReAuthCompleted() {
        const value = this.state.email;
        FirebaseUtils.updateEmail(value, (err)=>{
            if(err){
                this.setState({emailErr : err});
            }else {
                this.setState({loading : false});
                this.props.actions.updateUser(this.props.user.user.id, {email : value});
                CCAppEventLogger.logAppEvent("EmailUpdateCompleted",{});
            }
        });
        this.setState({screen : 'profile'});
    }

    _updateDetails() {
        this.setState({loading : true});
        if(this.props.user.user.displayName!=this.state.displayName){
            this._validateAndUpdateDisplayName(this.state.displayName, ()=>{
                this.setState({loading : false});
            });
        }
        if(this.props.user.user.email!=this.state.email) {
            this._reAuthenticate()
        }
    }


    render() {
        let user = this.props.user.user;
        const {screen} = this.state;
        return (

            <div className="sidebar-sub-background">
                {
                    (user.id && true) &&
                    <div className="flex-container" style={{resizeMode: 'cover'}}>
                        {
                            screen == 'profile' &&
                            <div style={{flex: 1}}>
                                <CCMoreModalItem dpLoading={this.state.dpLoading} dpEditable={true}
                                                 onDpPress={this._uploadProfilePicture} type={'user'}
                                                 user={user}></CCMoreModalItem>
                                <div className="profile-bg2">
                                    <CCInput type="text" style={{color: '#ffffff'}} value={this.state.displayName}
                                             immediate={true} onChange={e => this.onTodoChange(e.target.value)}
                                             label={strings('display_name')} onEndEditing={(displayName) => {
                                        this.setState({displayName})
                                    }}/>
                                    <CCInput editable={!this.props.user.user.emailVerified} value={this.state.email}
                                             immediate={true} label={strings('email_title')} type={"email"}
                                             onEndEditing={(email) => {
                                                 this.setState({email})
                                             }}/>
                                    <CCButton className={'profile-btn'} titleClassName={'text'}
                                              loading={this.state.loading} title={strings('save')}
                                              style={{marginTop: 20}} onPress={this._updateDetails}></CCButton>
                                </div>

                            </div>
                        }
                        {
                            screen == 'reAuth' &&
                            <ReAuth onReAuthCompleted={()=> {
                                this._onReAuthCompleted()
                            }}></ReAuth>
                        }
                    </div>
                }
            </div>
        )
    }
}

export default connect(state=>({
    profile : state.profile,
    profileTabNavigation:state.profileTabNavigation,
    user : state.user
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(Profile);



// WEBPACK FOOTER //
// ./src/app/screens/Profile/Profile.js